import { useState, useEffect, useContext, useRef } from 'react';
import callContext from '@/pages/crm/callCenter/callManage/callManageContext'
import { Spin } from 'antd';
import { SGeneralForms } from 'shj-components';
import CheckThePhone, { CheckThePhoneFormItem } from '@/components/CheckThePhone';
import styles from "../../index.module.less"
import {findCustomerMemberInfo} from "@/services/customerServices.ts";
function UserInfoModule(props: any) {
  const { callManageState } = useContext(callContext)
  const { callDetails } = callManageState
  const [loading, setLoading] = useState(false);
  const [customerInfo, setCustomerInfo] = useState({});
  const formRef = useRef()
  useEffect(() => {
    if (!callDetails.id) {
      formRef?.current?.onReset()
    }else{
      getCInfo()
    }
  }, [callDetails]);

  const getCInfo = () =>{
    console.log(callDetails)
    findCustomerMemberInfo(callDetails.customerId).then(res => {
      console.log(res)
      setCustomerInfo(res)
    })
  }

  const phoneRender = () => {
    return (
      <div>
        {callDetails.phone && (
            <CheckThePhone
                key={callDetails.id}
                clueId={callDetails.id}
                initValue={callDetails.phone}
                auth="callViewPhone"
            />
        )}
      </div>
    )
  };
  return (
    <div
      // style={{ height: 'calc(100vh - 500px)', overflowY: "auto" }}
      className={styles.userInfoModule}
    >
      <Spin tip="Loading" size="small" spinning={loading}>
        <div style={{ padding: '15px 15px 0' }}>
          <SGeneralForms
            ref={formRef}
            detailsData={{...callDetails, ...callDetails.customerInfo, ...callDetails.dtlInfo, ...callDetails.houseInfo}}
            isDetail={true}
            configs={[
              {
                title: '客户信息',
                formItem: [
                  { name: 'orgName', label: '所属门店', spanCol: 8 },
                  { name: 'name', label: '客户姓名', spanCol: 8 },
                  { name: 'phone', label: '客户号码', spanCol: 8, children: () => phoneRender() },
                  { name: 'gender', label: '性别', spanCol: 8 },
                  { name: 'age', label: '年龄', spanCol: 8 },
                  { name: 'birthday', label: '生日', spanCol: 8, type: 'date' },
                  { name: 'careerName', label: '职业', spanCol: 8 },
                  { name: 'email', label: '邮箱', spanCol: 8 },
                ],
              },
              {
                title: '楼盘信息',
                formItem: [
                  { name: 'buildingName', label: '楼盘名称', spanCol: 8 },
                  { name: 'doorNo', label: '门牌号', spanCol: 8 },
                  { name: 'houseNatureName', label: '房屋属性', spanCol: 8 },
                  { name: 'houseStatusName', label: '房屋状态', spanCol: 8 },
                  { name: 'houseKindName', label: '房屋类型', spanCol: 8 },
                  { name: 'layoutName', label: '户型', spanCol: 8 },
                  { name: 'constructArea', label: '建筑面积', spanCol: 8 },
                  { name: 'innerArea', label: '套内面积', spanCol: 8 },
                  { name: 'houseHight', label: '层高', spanCol: 8 },
                  { name: 'handoverDate', label: '交房日期', spanCol: 8, type: 'date' },
               ]
              },
              {
                title: '家空间需求',
                formItem: [
                  { name: 'bizTypeNames', label: '客户需求标签', spanCol: 8 },
                  { name: 'budgetName', label: '装修预算', spanCol: 8 },
                  { name: 'designStyleName', label: '装修风格', spanCol: 8 },
                  { name: 'intentionProductName', label: '产品意向', spanCol: 8 },
                  { name: 'houseDemandName', label: '功能需求', spanCol: 8 },
                  { name: 'expectRenovationDate', label: '预计进场装修日期', spanCol: 8, type: 'date'},
                  { name: 'estimatedRenovationTime', label: '预计装修日期', spanCol: 8, type: 'date'},
                  { name: 'lookingForwardToStayingTime', label: '期待入住时间', spanCol: 8, type: 'date'},

                  { name: 'painPointName', label: '痛点', spanCol: 24 },
                  { name: 'painPointRemark', label: '痛点备注', spanCol: 24 },
                  { name: 'itchPointName', label: '痒点', spanCol: 24 },
                  { name: 'itchPointRemark', label: '痒点备注', spanCol: 24 },
                  { name: 'breakPointName', label: '爆破点', spanCol: 24 },
                  { name: 'breakPointRemark', label: '爆破点备注', spanCol: 24 },
                  { name: 'blockPointName', label: '障碍点', spanCol: 24 },
                  { name: 'blockPointRemark', label: '障碍点备注', spanCol: 24 },
                  { name: 'remark', label: '备注信息', spanCol: 24 },
                ],
              },
            ]}
          />
        </div>
      </Spin>
    </div>
  );
}

export default UserInfoModule;